import { orderData } from '@/services/MockData/Order/OrderOverview/OrderOverview'
import { HTTP_METHODS } from '@/utils/constants/httpMethods'

export const ORDER_OVERVIEW_CONFIG = {
  ORDER_DETAIL: {
    endPoint: 'orders/overview',
    method: 'GET',
    mockData: orderData,
    baseUrlKey: 'omsApiUrl',
  },
  ORDER_OFFLINE_DETAILS: (queryParams, typeOfOrder) => {
    let endPoint = 'orders?orderType=OFFLINE&' + queryParams;
    if (typeOfOrder) {
      endPoint += `&typeOfOrder=${typeOfOrder}`;
    }
    return {
      endPoint,
      baseUrlKey: 'omsApiUrl', // Dynamically use OMS_API_URL
      method: HTTP_METHODS.POST,
    };
  },
  ORDER_ONLINE_DETAILS: (queryParams, typeOfOrder) => {
    let endPoint = 'orders?orderType=ONLINE&' + queryParams;
    if (typeOfOrder) {
      endPoint += `&typeOfOrder=${typeOfOrder}`;
    }
    return {
      endPoint,
      baseUrlKey: 'omsApiUrl', // Dynamically use OMS_API_URL
      method: HTTP_METHODS.POST,
    };
  },
}
